// src/components/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { MyContext } from "../context/context";
import Cookies from "js-cookie";

const ProtectedRoute = ({ children }) => {
  const token = Cookies.get("token");
  const SD = JSON.parse(localStorage.getItem("student"));

  // Check login status
  if (token === undefined || SD === null) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
